import { useDataSubmit } from 'Simple/Data'

export function useOnClick(props) {
  let submit = useDataSubmit({
    viewPath: props.viewPath,
    context: 'edit_address',
  })
  return async function onClick() {
    submit({ type: 'new_address_for_patient' })
  }
}
